module.exports = __webpack_public_path__ + "media/es_slide20_sweep_capsa.44c784b7.mp4";